// extracted by mini-css-extract-plugin
export var colorSquare = "_qq-0";
export var danger = "_qq-5";
export var lightPink = "_qq-8";
export var neutralBlue = "_qq-7";
export var neutralYellow = "_qq-6";
export var normal = "_qq-1";
export var primary = "_qq-2";
export var primaryLight = "_qq-3";
export var solidBlack = "_qq-g";
export var solidGreen = "_qq-b";
export var solidLightBlue = "_qq-d";
export var solidNavy = "_qq-c";
export var solidOrange = "_qq-f";
export var solidPink = "_qq-e";
export var solidRed = "_qq-9";
export var solidYellow = "_qq-a";
export var success = "_qq-4";